// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__-yK9Z","head":"Table_head__H7r7o","col":"Table_col__1zfF3"};